import React from "react";
import { useApplication } from "../../contexts/ApplicationContext";

const FooterQuery = ({ hasHeader = "true" }) => {
  const { user } = useApplication();
  return (
    <>
      {hasHeader === "true" && (
        <>
          {user?.Company?.showLogo && (
            <>
              <div className="mb-5"></div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default FooterQuery;
